import { render, staticRenderFns } from "./front-matter.vue?vue&type=template&id=4cbb79e8"
import script from "./front-matter.ts?vue&type=script&lang=ts&external"
export * from "./front-matter.ts?vue&type=script&lang=ts&external"
import style0 from "./front-matter.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports